/**
 * Ordered ranking for Home's featured-deal slot — first eligible slug wins.
 * A slug absent from this list is never featured, so this doubles as the
 * "eligible at all" filter.
 *
 * Editorial, not derived. Today the order happens to track payout, but the
 * whole point of a hand-kept list is being able to push a deal that converts
 * better than it pays. Fetch is deliberately omitted: at $5 it's the weakest
 * pitch for a hero slot, and it's one tap away on the Deals tab anyway.
 *
 * This lives on the client, so changing it ships as an OTA **plus** a web
 * redeploy (web is a separate `npm run build-web`). That was the accepted
 * trade for keeping the feature app-only. If re-ranking becomes a monthly
 * chore, promote it to a `deals.featured_rank` column and have
 * `dealsStore.featuredDeal` read that instead — nothing else has to move.
 *
 * A typo here silently means "never featured" — there's no server to catch
 * it and no build-time slug list any more (share previews are served live),
 * so double-check a new slug against `GET /api/v1/public/deals`.
 */
export const FEATURED_DEAL_SLUGS = [
  'sofi-checking-2026',
  'sofi-invest-2026',
  'sofi-crypto-2026',
  'upside-2026',
  'capital-one-shopping-2026',
] as const;
